import { gql } from '@apollo/client';

const GET_ENABLED_CATALOG_FEATURES = gql`
  query getEnabledCatalogFeatures {
    getEnabledCatalogFeatures
  }
`;

export default GET_ENABLED_CATALOG_FEATURES;
